import { EmbeddedMessage, MessageMedium } from 'constants/messageMediums';
import { CampaignTypeFilter } from 'modules/domains/campaign';
import { ComparisonOperator } from '../constants';

export enum MetricType {
  Percentage = 'percentage',
  Number = 'number',
}

export const Blast = { type: CampaignTypeFilter.Blast, displayName: 'blast' };
export const Triggered = { type: CampaignTypeFilter.Triggered, displayName: 'triggered' };
export const Eligibility = { type: CampaignTypeFilter.Eligibility, displayName: 'eligibility' };

const BlastAndTriggered = [Blast, Triggered];

export type CampaignTypeData = { type: CampaignTypeFilter; displayName: string };
type MediumAndTypes = { medium: MessageMedium; types: CampaignTypeData[] };

export const MESSAGE_MEDIUMS_TO_CAMPAIGN_TYPES: MediumAndTypes[] = [
  { medium: MessageMedium.Email, types: BlastAndTriggered },
  { medium: MessageMedium.Push, types: BlastAndTriggered },
  { medium: MessageMedium.SMS, types: BlastAndTriggered },
  { medium: MessageMedium.InApp, types: BlastAndTriggered },
  { medium: MessageMedium.WebPush, types: BlastAndTriggered },
  { medium: EmbeddedMessage, types: [Eligibility] },
];

/**
 * May be removed later if backend starts returning this data
 */
export const METRICS_TO_COMPARATORS: Record<string, ComparisonOperator> = {
  // Email
  EmailOpenRate: ComparisonOperator.LessThan,
  EmailClickRate: ComparisonOperator.LessThan,
  EmailBounceRate: ComparisonOperator.GreaterThan,
  EmailUnsubscribeRate: ComparisonOperator.GreaterThan,
  TotalEmailSend: ComparisonOperator.LessThan,
  TotalEmailOpen: ComparisonOperator.LessThan,
  TotalEmailClick: ComparisonOperator.LessThan,
  TotalEmailComplaintRate: ComparisonOperator.GreaterThan,

  // Push
  PushOpenRate: ComparisonOperator.LessThan,
  PushBounceRate: ComparisonOperator.GreaterThan,
  TotalPushSend: ComparisonOperator.LessThan,
  TotalPushOpen: ComparisonOperator.LessThan,

  // SMS
  SMSClickRate: ComparisonOperator.LessThan,
  SMSBounceRate: ComparisonOperator.GreaterThan,
  SMSUnsubscribeRate: ComparisonOperator.GreaterThan,
  TotalSMSSend: ComparisonOperator.LessThan,

  // In-app
  InAppClickRate: ComparisonOperator.LessThan,
  TotalInAppSend: ComparisonOperator.LessThan,
  TotalInAppClick: ComparisonOperator.LessThan,

  // Web push
  TotalWebPushClick: ComparisonOperator.LessThan,
  TotalWebPushSend: ComparisonOperator.LessThan,

  // Embedded
  TotalEmbeddedImpression: ComparisonOperator.LessThan,
};
